import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { FeaturedServices } from '../components/FeaturedServices';
import { InsuranceRibbon } from '../components/InsuranceRibbon';
import { Financing } from '../components/Financing';
import { ContactUs } from '../components/ContactUs';
import { Testimonials } from '../components/Testimonials';
import { Footer } from '../components/Footer';
import { useScreenInit } from '../useScreenInit';
export function LandingPage() {
  useScreenInit();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, []);
  return <div className="min-h-screen bg-white selection:bg-teal-100 selection:text-teal-900" data-id="element-670">
      <Header data-id="element-671" />
      <main data-id="element-672">
        <Hero data-id="element-673" />
        <InsuranceRibbon data-id="element-674" />
        <FeaturedServices data-id="element-675" />
        <Financing data-id="element-676" />
        <Testimonials data-id="element-677" />
      </main>
      <Footer data-id="element-678" />
    </div>;
}